const routes = [
  {
    path: ["/", "/home", "/ma-tutorbox"],
    exact: true,
    component: "MaTutorBox",
  },
  {
    path: "/thank-you",
    exact: true,
    component: "ThankYou",
  },
  {
    path: "/privacy",
    exact: true,
    component: "PaddlePrivacy",
  },
  {
    path: "/refund",
    exact: true,
    component: "PaddleRefund",
  },
  {
    path: "/terms",
    exact: true,
    component: "PaddleTerms",
  },
];

export default routes;
